import { jsx as _jsx } from "react/jsx-runtime";
import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../hooks/useAuth';
var PrivateRoute = function (_a) {
    var element = _a.element;
    var _b = useAuth(), authenticated = _b.authenticated, initialized = _b.initialized;
    if (!initialized) {
        return null;
    }
    return authenticated ? element : _jsx(Navigate, { to: "/login", replace: true });
};
export default PrivateRoute;
